import React from "react";
import { videoCallConstants } from "../../../constants/videoCall.constants";
import PhoneDisabledIcon from "@material-ui/icons/PhoneDisabled";
import CallEndIcon from "@material-ui/icons/CallEnd";
import PhoneIcon from "@material-ui/icons/Phone";
import { Button } from "@material-ui/core";
import { JitsiWrapper, JitsiWrapper2 } from "../../../../plugins/JitsiWrapper";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";

export const VideoFrame = (props) => {
  const {
    connected,
    selectedChat,
    videoCallActive,
    videoCallTarget,
    clientKey,
    displayName,
    closeVideoCall,
    targetPerson = "",
    page,
    meetingCode = "",
  } = props;

  const frameStyle = page != "CHAT" ? { opacity: 0, zIndex: 1 } : undefined;
  const frameClassName =
    page == "CHAT"
      ? selectedChat
        ? "expo-admin-video-view-50"
        : "expo-admin-video-view-100"
      : "expo-admin-video-view-flex";

  const height = page != "CHAT" ? "39vh" : "calc(100vh - 64px )";

  if (videoCallTarget && connected) {
    return (
      <div style={frameStyle} className={frameClassName}>
        {videoCallActive ? (
          <JitsiWrapper
            roomName={meetingCode}
            displayName={displayName}
            height={height}
            onHangup={() => closeVideoCall(videoCallTarget)}
          />
        ) : (
          <div className="call-loader">
            <CallLoader {...props} />
          </div>
        )}
      </div>
    );
  }

  return null;
};

const CallLoader = (props) => {
  const {
    videoCallActive,
    orderList,
    videoCallResponse,
    videoCallTarget,
    videoRequestResponse,
    callId,
    lang
  } = props;
  const targetPerson = orderList.find((o) => o.badgeNo == videoCallTarget)
    ? orderList.find((o) => o.badgeNo == videoCallTarget)?.name ?? " - "
    : null;

  if (videoCallResponse == videoCallConstants.CALL_DENIED) {
    return (
      <div className="centered-text">
        <div class="call-animation-end">
          <PhoneDisabledIcon
            style={{
              top: "26%",
              position: "absolute",
              color: "#fff",
              left: "23%",
              fontSize: "50px",
            }}
          />
        </div>
        <br />
        <h2>
          {" "}
          {targetPerson}{" "}
          <SystemLabel name="DeniedCall" languageCode={lang} />
        </h2>
      </div>
    );
  }
  if (videoCallResponse == videoCallConstants.SELF_HANGUP) {
    return (
      <div className="centered-text">
        <div className="call-animation-end">
          <CallEndIcon
            style={{
              top: "26%",
              position: "absolute",
              color: "#fff",
              left: "23%",
              fontSize: "50px",
            }}
          />
        </div>
        <br />
        <h2>
          {" "}
          <SystemLabel name="YouHungUp" languageCode={lang} />
        </h2>
      </div>
    );
  }
  if (videoCallResponse == videoCallConstants.TARGET_HANGUP) {
    return (
      <div className="centered-text">
        <div className="call-animation-end">
          <CallEndIcon
            style={{
              top: "26%",
              position: "absolute",
              color: "#fff",
              left: "23%",
              fontSize: "50px",
            }}
          />
        </div>
        <br />
        <h2>
          {" "}
          {targetPerson}{" "}
          <SystemLabel name="HungUp" languageCode={lang}/>
        </h2>
      </div>
    );
  }
  return (
    <div className="centered-text">
      <div className="call-animation">
        <PhoneIcon
          style={{
            top: "26%",
            position: "absolute",
            color: "#5e7bff",
            left: "23%",
            fontSize: "50px",
          }}
        />
      </div>
      <br />
      <h2>
        {" "}
        <SystemLabel name="YouAreCalling" languageCode={lang} />{" "}
        {targetPerson}
      </h2>
      <br />
      <br />
      <div style={{ textAlign: "center", width: "100%" }}>
        <Button
          className="call-btn end"
          onClick={() =>
            videoRequestResponse(false, videoCallTarget, callId, true)
          }
          color="primary"
        >
          <CallEndIcon />
        </Button>
      </div>
    </div>
  );
};
